import BackofficeServicesRepository from '@/_shared/repositories/backoffice-services.repository';
import IdentifierInterface from '@/_shared/interfaces/identifier.entity';
import PlacementQuery from '@/manage/interface/placement-query.interface';
import GenealogyType from '@/_shared/enums/genealogy-type.enum';

class OrganizationService {
  private boServicesRepository: BackofficeServicesRepository = new BackofficeServicesRepository();

  public getGenealogyDistributors(
    repDid: string | number,
    query: PlacementQuery,
    type: GenealogyType = GenealogyType.PLACEMENT,
  ): Promise<IdentifierInterface[]> {
    return this.boServicesRepository.get(`/distributors/genealogy/${type}/${repDid}`, {
      withCredentials: false,
      headers: {},
      params: {
        'filter[hide-cancelled]': query.hideCancelled,
        'filter[hide-zerogqv]': query.hideZeroGQV,
        value: query.value,
      },
    }).then(({ data }) => data.names);
  }
}

export default new OrganizationService();
